import { useAtom, useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { activeConversationIdAtom, mobileConversationDetailVisibleAtom } from '../store';

export const useSyncActiveConversationWithQuery = () => {
  const router = useRouter();
  const [activeConversationId, setActiveConversationId] = useAtom(activeConversationIdAtom);
  const setIsMobileDetailVisible = useSetAtom(mobileConversationDetailVisibleAtom);

  useEffect(() => {
    const conversationId = router.query.conversationId?.[0];
    if (router.isReady && conversationId && conversationId !== activeConversationId) {
      setActiveConversationId(conversationId);
      setIsMobileDetailVisible(true);
    }
  }, [router]);

  useEffect(() => {
    if (activeConversationId) {
      router.push(`/a/inbox/${activeConversationId}`, undefined, { shallow: true });
    }
  }, [activeConversationId]);
};
